//@flow
import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import ProdutoBloqueadoCrudList from './ProdutoBloqueadoCrudList';
import ProdutoBloqueadoEdit from './ProdutoBloqueadoEdit';
export default class ProdutoBloqueadoCrud extends React.PureComponent<{}> {
  render() {
    return (
      <React.Fragment>
        <Switch>
          <Route
            path="/produtoBloqueado"
            exact
            component={ProdutoBloqueadoCrudList}
          />
          <Route
            path="/produtoBloqueado/novo"
            exact
            component={ProdutoBloqueadoEdit}
          />
          <Route
            path="/produtoBloqueado/:id"
            component={ProdutoBloqueadoEdit}
          />
        </Switch>
      </React.Fragment>
    );
  }
}
